import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HotelRoomPriceOrdering } from '@shared/models/hotel-search-response.model';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { ISiteSettings } from '@shared/shared/interfaces/site-settings.interfaces';
import { of, switchMap, withLatestFrom } from 'rxjs';
import * as fromActions from '../actions/hotel-room.actions';

@Injectable()
export class HotelRoomEffects {
  constructor(private actions$: Actions, private siteSettingsService: SiteSettingsService) {}

  public SetHotelRooms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.SET_HOTEL_ROOM_RESULTS),
      withLatestFrom(this.siteSettingsService.fetchSiteSettings()),
      switchMap(([action, settings]: [fromActions.SetHotelRoomResults, ISiteSettings]) => {
        const defaultPriceOrder =
          settings.hotel_room_ordering_level?.sort_by_price_ascending !== false
            ? HotelRoomPriceOrdering.ASCENDING
            : HotelRoomPriceOrdering.DESCENDING;
        const selectedPriceOrder = settings.hotel_room_ordering_level?.product_group?.length
          ? HotelRoomPriceOrdering.RECOMMENDED
          : defaultPriceOrder;
        return of(
          new fromActions.SetHotelRoomResultsSuccess({
            rooms: action.payload.rooms,
            roomRequests: action.payload.roomRequests,
            productGroupsForBanner: settings.product_group_ordering,
            productGroups: settings.hotel_room_ordering_level.product_group,
            isPricePerRoomPerNight: settings.switches.travel_hotels_rooms_price_per_night,
            isProductGroupOrdering: !!settings.hotel_room_ordering_level?.product_group?.length,
            defaultPriceOrder,
            selectedPriceOrder,
            hotelId: action.payload.hotelId,
          })
        );
      })
    )
  );
}
